import {createReducer} from "@reduxjs/toolkit";
import {translate} from '@elements/translations';
import {FETCHING_STATE} from "../../shared/utils";

import {
    LIST_DATA_FETCH_FAILED_ACTION_TYPE,
    LIST_DATA_FETCHED_ACTION_TYPE,
    LIST_DATA_FETCH_ACTION_TYPE,
    LIST_DATE_CHANGED, LIST_INVOICES_FETCHED_ACTION_TYPE, LIST_INVOICES_FETCH_FAILED_ACTION_TYPE, LIST_INVOICES_FETCH_ACTION_TYPE
} from "../actions/actions";

const getDefaultsFromUrl = (param, fallback) => {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(param);
    return value ? Number(value) : fallback;
};

const initialState = {
    fetchingState: '',
    invoicesFetchingState: '',
    items: [],
    date: {
        startDate: getDefaultsFromUrl('startDate', new Date(new Date().getFullYear(), 0, 1).getTime()),
        endDate: getDefaultsFromUrl('endDate', new Date().getTime())
    },
    invoices: {},
    deliveryNotes: {},
    orders: {},
    availableCategories: []
};

export default createReducer(initialState, {
    [LIST_DATA_FETCH_ACTION_TYPE]: (state, {payload}) => {
        state.fetchingState = FETCHING_STATE.PENDING;
    },
    [LIST_DATA_FETCHED_ACTION_TYPE]: (state, {payload}) => {
        state.fetchingState = FETCHING_STATE.SUCCESS;
        state.items = payload.data || [];

        payload.data.forEach((item) => {
            if (!state.availableCategories.some(cat => cat.value === item.submitType)) {
                state.availableCategories.push({label: translate(`order-archive.type.${item.submitType}`), value: item.submitType});
            }
        });
    },
    [LIST_DATA_FETCH_FAILED_ACTION_TYPE]: (state) => {
        state.fetchingState = FETCHING_STATE.ERROR;
    },
    [LIST_DATE_CHANGED]: (state, {payload: {date}}) => {
        state.date = date;
    },
    [LIST_INVOICES_FETCH_ACTION_TYPE]: (state) => {
        state.invoicesFetchingState = FETCHING_STATE.PENDING;
    },
    [LIST_INVOICES_FETCHED_ACTION_TYPE] : (state, {payload}) => {
        state.invoices = {...state.invoices, ...payload.selectedInvoices.reduce((acc, invoice) => {
                acc[invoice.number] = invoice;
                return acc;
            }, {})
        };

        state.deliveryNotes = {...state.deliveryNotes, ...payload.selectedDeliveryNotes.reduce((acc, note) => {
                acc[note.number] = note;
                return acc;
            }, {})
        };

        state.orders = {...state.orders, ...payload.selectedPurchaseOrder.reduce((acc, note) => {
                acc[note.number] = note;
                return acc;
            }, {})
        };

        state.invoicesFetchingState = FETCHING_STATE.SUCCESS;
    },
    [LIST_INVOICES_FETCH_FAILED_ACTION_TYPE]: (state) => {
        state.invoicesFetchingState = FETCHING_STATE.ERROR;
    }
});

// selectors
export const getFetchingState = (state) => state.fetchingState;
export const getItems = (state) => state.items;
export const getAvailableCategories = (state) => state.availableCategories;
export const getStartDate = (state) => state.date.startDate;
export const getEndDate = (state) => state.date.endDate;
export const getInvoicesFetchingState = (state) => state.invoicesFetchingState;
export const getNotesByIds = (state, ids) => {
    return ids.reduce((acc, id) => {
        if (state.deliveryNotes[id]) {
            acc[id] = state.deliveryNotes[id];
        }
        return acc;
    }, {});
}
export const getInvoicesByIds = (state, ids) => {
    return ids.reduce((acc, id) => {
        if (state.invoices[id]) {
            acc[id] = state.invoices[id];
        }
        return acc;
    }, {});
}
export const getOrdersById = (state, ids) => {
    return ids.reduce((acc, id) => {
        if (state.orders[id]) {
            acc[id] = state.orders[id];
        }
        return acc;
    }, {});
}